var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SoundManager } from "../manager";
var SoundWrapper = /** @class */ (function (_super) {
    __extends(SoundWrapper, _super);
    function SoundWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            sound: props.sound
        };
        return _this;
    }
    SoundWrapper.prototype.componentWillReceiveProps = function (newProps) {
        var _this = this;
        if (newProps.sound && this.state.sound && newProps.sound.id === this.state.sound.id) {
            if (new Date(newProps.sound.updated_at) > new Date(this.state.sound.updated_at)) {
                this.setState({ sound: newProps.sound });
            }
        }
        else {
            this.unregisterListener();
            this.setState({ sound: newProps.sound }, function () { _this.registerListener(); });
        }
    };
    SoundWrapper.prototype.componentDidMount = function () {
        this.registerListener();
    };
    SoundWrapper.prototype.componentWillUnmount = function () {
        this.unregisterListener();
    };
    SoundWrapper.prototype.registerListener = function () {
        var _this = this;
        this._postsStateListener = SoundManager.getInstance().addSoundStateListener(this.state.sound, function (sound) {
            if (_this.state.sound.id === sound.id) {
                _this.setState({ sound: sound });
            }
        });
    };
    SoundWrapper.prototype.unregisterListener = function () {
        this._postsStateListener && SoundManager.getInstance().removeSoundStateListener(this.props.sound, this._postsStateListener);
    };
    SoundWrapper.prototype.render = function () {
        var sound = this.state.sound;
        return this.props.children(sound);
    };
    return SoundWrapper;
}(React.Component));
export default SoundWrapper;
//# sourceMappingURL=sound.js.map